import React from 'react';
import styled from "styled-components";
import Link from "next/link";
import ButtonBase from "../../../../atoms/button.base";
import Icon from "../../../../atoms/icon";
import {handleBrandUrl} from "../../../navbar/helpers";
import WhiteDonabshIcon from "@icons/white-2nabsh.svg";

const HayaatMainSection = ({windowSize, investTopButtonRef, showInvestForm, defaultCity}) => {

    return (
        <Container className="d-flex flex-column justify-content-start justify-content-lg-between">
            <div className="container d-flex mt-16 mt-lg-24 align-items-center justify-content-center justify-content-lg-start z-index10">
                <div className="white-donabsh-icon">
                    <Link href="/properties" as={handleBrandUrl(defaultCity)}>
                        <a>
                            <Icon className="icon-white" width={windowSize > 991 ? "80" : "72"}><WhiteDonabshIcon/></Icon>
                        </a>
                    </Link>
                </div>
            </div>

            <div className="container z-index10 section-content">
                <h1 className="text-white">
                    <span>تجربه زندگی</span><br/>
                    <span>در هتلی در چند قدمی <br className="d-inline-block d-lg-none"/><strong>حرم امام رضا(ع)</strong></span><br/>
                    <span>اما در آپارتمان خودتان!</span>
                </h1>

                <div className="investment-btn-card">
                    <Button
                        buttonRef={investTopButtonRef}
                        className="yellow-button mt-24 mt-lg-0"
                        onClick={() => showInvestForm()}
                        color=""
                        block={(windowSize <= 991)}>
                        دریافت اطلاعات بیشتر
                    </Button>
                </div>
            </div>
        </Container>
    );
};

export default React.memo(HayaatMainSection);

// styles

const Container = styled.section`
    background: ${props => props.theme.primary} url('/_img/landings/hayaat/hayat-bg-desktop.jpg') no-repeat;
    background-size: cover;
    background-position: top;
	position: relative;
    height: 100vh;
	padding-bottom: 80px;
	border-radius: 0;
   

    h1 {
		font-size: 50px;
		font-weight: 300;
        line-height: 1.33;
        
        span {
            background-color: ${props => props.theme.primary};
            padding: 8px 32px;
            line-height: 1.4;
        }
        
        strong {
            font-weight: 300;
            color: ${props => props.theme.yellow};
        }
    }

	.right-arrow-icon {
		cursor: pointer;
		
		&.icons {
			path {
				stroke: #fff;
			}
		}
	}
	
	.z-index10 {
        z-index: 10;
    }
    
    .investment-btn-card {
        display: inline-flex;
        background-color: ${props => props.theme.primary};
        padding: 24px 32px;
    }
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        background: ${props => props.theme.primary} url('/_img/landings/hayaat/hayat-bg-mobile.jpg') no-repeat;
        background-size: cover;
        background-position: top center;
        padding-bottom: 24px;
		min-height: 100vh;
        
        h1 {
              font-size: 30px;
              
              span {
                  background-color: transparent;
                  padding: 0;
              }
        }
        
        .investment-btn-card{
            background-color: transparent;
            padding: 0; 
        }
        
        .section-content {
            display: flex;
            flex-direction: column;
            margin-top: 64px;
            height: 100%;
            flex: 1;
            
            .investment-btn-card {
                margin-top: auto;
            }
        }
    }
    
`;

const Button = styled(ButtonBase)`
	background-color: transparent;
	border-color: ${props => props.theme.black};
	color: ${props => props.theme.black};
	
	&:hover {
		color: #fff;
		border-color: #fff;
		background-color: ${props => props.theme.black};
	}

	&.yellow-button {
		background-color: ${props => props.theme.yellow};
		border-color: ${props => props.theme.yellow};

		&:hover {
			color: ${props => props.theme.black};
			border-color: #e6b818;
			background-color: #e6b818;
		}
	}
	
	@media (max-width: ${props => props.theme.screenSmMax}) {
        position: fixed;
        bottom: 24px;
        right: 24px;
        left: 24px;
        width: calc(100% - 48px);
        z-index: 100;
    }
`;